import * as React from "react"
import { useState, useCallback, useEffect } from "react"
import cx from "classnames"

import Container from "@components/elements/container"
import Link from "@components/elements/link"
import Navigation from "./navigation"

import { internalRoutes } from "@data/routes"

import useScrollDirection from "@lib/useScrollDirection"
import useLockedBody from "@lib/useLockedBody"

import Logo from "@images/logo.inline.svg"
import styles from "./header.module.scss"

const Header = ({ headerFill, headerDark }) => {
  const [isOpen, setIsOpen] = useState(false)
  const close = () => setIsOpen(false)
  const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen])
  const scrollDirection = useScrollDirection()

  useEffect(() => {
    document.body.classList.remove("down", "up")
    scrollDirection && document.body.classList.add(scrollDirection)

    return () => {
      document.body.classList.remove("down", "up")
    }
  }, [scrollDirection])

  useEffect(() => {
    window.dispatchEvent(new Event("scroll"))
  }, [])

  useLockedBody(isOpen)

  return (
    <>
      <header
        className={cx(styles.header, styles[scrollDirection], {
          [styles.isFilled]: headerFill,
          [styles.isDark]: headerDark,
          [styles.isOpen]: isOpen,
        })}
      >
        <Container className={styles.container}>
          <Link
            className={styles.logo}
            url={internalRoutes.HOME}
            aria-label="Go to Homepage"
            onClick={close}
          >
            <Logo />
          </Link>
          <button
            className={styles.hamburger}
            type="button"
            onClick={toggle}
            aria-label="Open navigation"
          >
            <span className={styles.hamburgerText}>
              {isOpen ? "Close" : "Menu"}
            </span>
            <span className={styles.hamburgerLines}></span>
          </button>
          <Link className={styles.ctaButton} url={internalRoutes.CONTACT}>
            Contact
          </Link>
        </Container>
        <Navigation isOpen={isOpen} close={close} />
      </header>
    </>
  )
}

export default Header
